import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../../withApolloClient'
import RestrictedSection from "../../Components/RestrictedSection"
import TPAAdjustersList from './TPAAdjustersList'
import TPAAdjustersAction from './TPAAdjustersAction'
import TPAAdjustersListHeader from './TPAAdjustersListHeader'

const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "date_modified", name: "Date Modified", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "name", name: "Name", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "tpa", name: "TPA", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "phone", name: "Phone", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "email", name: "Email", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "role", name: "Role", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]

const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))

class TPAAdjustersListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-date_added"],
            filterValues: {},
            refetchTPAAdjustersList: false,
            columnConfig: getDefaultColumnConfig(),
        }
    }

    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };

    render() {
        return (
            <RestrictedSection requiredPermission="view_tpaadjuster">
                <Container fluid className="bos-listing-container">
                    <Row>
                        <Col xs={8}>
                            <TPAAdjustersListHeader
                                filterValues={this.state.filterValues}
                                setFilterValues={(filterValues) => this.setState({ filterValues })}
                                defaultFilters={this.state.filterValues}
                                {...this.props}
                            />
                        </Col>
                        <Col xs={4}>
                            <TPAAdjustersAction
                                columnConfig={this.state.columnConfig}
                                setColumnConfig={this.setColumnConfig}
                                tableId="tpa_adjusters"
                                defaultColumnConfig={getDefaultColumnConfig()}
                                refetchQuery={() => this.setState({ refetchTPAAdjustersList: !this.state.refetchTPAAdjustersList })}
                                {...this.props}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12">
                            <TPAAdjustersList
                                columnConfig={this.state.columnConfig}
                                key={String(this.state.refetchTPAAdjustersList)}
                                currentUser={this.props.currentUser}
                                tpaId={this.state.filterValues.tpaId}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}

export default withApolloClient(TPAAdjustersListContainer)
